import React, { useState, useEffect } from "react";
import Barcode from "react-barcode";
import { useNavigate } from "react-router-dom";
import "./PrintBadges.css";

const BADGE_TITLE = "Labnext Scan Badge";

// Har user ke liye chhota barcode code (e.g. U72908). Same user = hamesha same code.
export const getBadgeCode = (id = "") => {
  const s = String(id);
  if (/^\d{1,8}$/.test(s)) return "U" + s;
  let h = 0;
  for (const c of s) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return "U" + String(h % 1000000).padStart(6, "0");
};

const PrintBadges = () => {
    const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await fetch("https://hms.backend.hiragroupcloud.com/api/auth/labusers", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        });
        if (!res.ok) throw new Error(`Error: ${res.status}`);
        const data = await res.json();

        setUsers(
          Array.isArray(data.users)
            ? data.users.map((u) => ({
                id: u.userId || u._id,
                name: `${u.firstName || u.first_name || ""} ${
                  u.lastName || u.last_name || ""
                }`.trim(),
              }))
            : []
        );
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  return (
    <div className="badges-page">
    <div className="badges-note">
  <span>Be sure to disable print headers and footers</span>
  <div className="badges-actions">
    <button type="button" onClick={() => navigate(-1)}>Back</button>
    <button type="button" onClick={() => window.print()}>Print</button>
  </div>
</div>

      {loading && <p className="badges-msg">Loading badges...</p>}
      {error && <p className="badges-msg">Error: {error}</p>}

      <div className="badges-grid">
        {users.map((u) => {
          const code = getBadgeCode(u.id);
          return (
            <div className="badge-card" key={u.id}>
              <h2>{BADGE_TITLE}</h2>
              <h3>{u.name}</h3>
              <Barcode
                value={code}
                format="CODE39"
                displayValue={false}
                width={1.4}
                height={50}
                margin={0}
              />
              <div className="badge-code">*{code}*</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PrintBadges;